/**
 * 変数
 */

export const CATEGORY_NAME = [
  "",
  "商品性",
  "仕組み",
  "運用手法",
  "レバレッジ",
  "先物取引",
];
